module.exports = __webpack_public_path__ + "b85cb88fb37325acf1a4a9887794bf01.svg";